import {MenuItemTooltipTitle} from '@widgets/shift-event-filters'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

export const FilterIncompatibleTooltip = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  return (
    <MenuItemTooltipTitle
      title={t('filters.filterUnavailable')}
      message={t('filters.filterIncompatibleMessage')}
    />
  )
}
